export default "__VITE_ASSET__DLPiKmmx__"